import React, { useCallback, useState } from 'react'
import { Button } from '@/components/ui/button'
import { TicketDetailsDto } from 'api/Tickets/Types/TicketDetails'
import {
  FormBaseAntSelectWrapper,
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Loading } from 'components/Loading'
import { Option, Select } from 'components/Select'
import { useApiClient } from 'utils/api/ApiClient'
import { IdentityApiClient } from 'utils/api/identityApi'
import { useFetchOne } from 'utils/api/useFetch'

interface Props {
  data: TicketDetailsDto

  onSubmit(ticketId: string, assigneeId: string): void
}

export const TicketAssignee: React.FC<Props> = ({ onSubmit, data }) => {
  const [assigneeId, setAssigneeId] = useState<string>('')
  // id = 13 is a Translator
  const identityApiClient = useApiClient(IdentityApiClient)

  const usersData = useCallback(
    async () => await identityApiClient.getUsers([{ id: 13, name: 'Translator' }]),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  const { data: users, isLoading } = useFetchOne(usersData)
  const handleSubmit = () => {
    onSubmit(data.id, assigneeId)
  }
  return (
    <Loading isLoading={isLoading}>
      {users && (
        <FormBaseContainer>
          <form>
            <FormBaseFieldBlock>
              <FormBaseRow>
                <FormBaseFieldLabel>Assignee</FormBaseFieldLabel>
                <FormBaseFieldGroup>
                  <FormBaseAntSelectWrapper>
                    <Select
                      placeholder='Assignee'
                      value={undefined}
                      allowClear
                      showSearch
                      onChange={(value: string) => setAssigneeId(value)}
                    >
                      {users.map((userResponse) => (
                        <Option value={userResponse.id} key={userResponse.id}>
                          {userResponse.name}
                        </Option>
                      ))}
                    </Select>
                  </FormBaseAntSelectWrapper>
                </FormBaseFieldGroup>
              </FormBaseRow>
            </FormBaseFieldBlock>
            <FormBaseButtonContainer>
              <Button type='button' disabled={!assigneeId} onClick={() => handleSubmit()}>
                Submit
              </Button>
            </FormBaseButtonContainer>
          </form>
        </FormBaseContainer>
      )}
    </Loading>
  )
}
